import { useState, useEffect } from "react";
import Header from "../asset/img/Merch.png";
import FloatingMenu from "../components/FloatingMenu";

const Merchandise = () => {
  const [datas, setDatas] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/merchandises"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data merchandise");
      }
      const data = await response.json();
      const merch = data.data;
      merch.sort((a, b) => a.id - b.id);

      const merchandiseData = merch.map((item) => {
        return {
          id: item.id,
          images: [item.image],
          title: item.title,
          price: item.price,
          stock: item.stock,
          description: item.description,
          url: item.url,
        };
      });

      setDatas(merchandiseData);
    } catch (error) {
      setDatas([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="bg-gray-100">
        <div className="mt-24">
          <img className="w-full" src={Header} alt="Header" />
        </div>
        <div className="mt-12 text-center my-6 text-5xl font-bold leading-[57.6px] max-md:max-w-full max-md:text-4xl">
          <h1>Merchandise OK OCE</h1>
        </div>
        <div
          id="products"
          className="mt-[3rem] w-full flex justify-center bg-gray-100 text-slate-700"
        >
          <div className="w-3/4 grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {datas.length > 0 ? (
              datas.map((item, currentItemIndex) => (
                <div
                  key={item.id}
                  className="rounded-xl flex flex-col bg-white p-4"
                >
                  <div className="mx-auto mb-4 w-full">
                    <div className="relative rounded-t-lg overflow-hidden shadow-lg">
                      <img
                        src={`https://cms.okoce.net/storage/${item.images[0]}`}
                        className="object-cover w-full h-full"
                        alt={item.title}
                      />
                    </div>
                  </div>

                  <div className="w-full pl-0 lg:py-2 lg:px-2 font-poppins flex flex-col justify-between">
                    <div className="flex flex-wrap">
                      <h2 className="flex-auto text-xl font-semibold text-black">
                        {item.title}
                      </h2>
                      <div className="text-xl font-semibold text-black">
                        Rp{item.price.toLocaleString()}
                      </div>
                      <div className="flex-none w-full mt-2 text-sm font-medium text-gray-500">
                        Sisa stok: {item.stock}
                      </div>
                      <div className="mt-6">
                        <p className="text-justify text-black">
                          {item.description.replace(/<[^>]+>/g, "")}
                        </p>
                      </div>
                    </div>
                    <div className="flex text-sm font-medium mt-4 mb-2">
                      <a
                        href={`${item.url}${item.title}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="py-2 px-4 bg-[#1c75ac] hover:bg-blue-700 focus:ring-[#1c75ac] focus:ring-offset-indigo-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg w-full"
                      >
                        Beli sekarang
                      </a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="loading-container">
                <div className="spinner"></div>
              </div>
            )}
          </div>
        </div>
        <FloatingMenu />
      </div>
    </>
  );
};

export default Merchandise;
